/**
 * Workflow Session Service
 * Workflow session management service API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CurrentStepDto } from './currentStepDto';


export interface WorkflowSessionResponseDto { 
    /**
     * The unique identifier of the workflow session
     */
    id: string;
    /**
     * The workflow key identifying the workflow type
     */
    workflowKey: string;
    /**
     * Optional session key for identifying duplicate workflows
     */
    sessionKey?: string | null;
    /**
     * The current status of the workflow session
     */
    status: WorkflowSessionResponseDto.StatusEnum;
    /**
     * The current step information (null if completed)
     */
    currentStep?: CurrentStepDto | null;
    /**
     * Progress percentage (0-100)
     */
    progress: number;
    /**
     * Context data accumulated during workflow execution
     */
    contextData: any;
    /**
     * Session-level data from the workflow
     */
    data?: any | null;
    /**
     * Additional data passed through to the workflow by the caller
     */
    additionalData?: any | null;
    /**
     * Response data from the last ActivePieces execution
     */
    response?: any | null;
    /**
     * Error information if the session failed
     */
    error?: any | null;
    /**
     * When the session expires (ISO 8601 format)
     */
    expiresAt: string;
    /**
     * Patient ID (null for SuperTokens user sessions)
     */
    patientId?: string | null;
    /**
     * When the session was created (ISO 8601 format)
     */
    createdAt: string;
    /**
     * When the session was last updated (ISO 8601 format)
     */
    updatedAt: string;
}
export namespace WorkflowSessionResponseDto {
    export type StatusEnum = 'active' | 'completed' | 'abandoned' | 'expired' | 'failed';
    export const StatusEnum = {
        Active: 'active' as StatusEnum,
        Completed: 'completed' as StatusEnum,
        Abandoned: 'abandoned' as StatusEnum,
        Expired: 'expired' as StatusEnum,
        Failed: 'failed' as StatusEnum
    };
}


